import { ActivityProps, BlockContent, BlockContentWrapper } from '~/bootcamp/Activities/types/activities.types'

export type Id = string | number

export interface CategorizationProps extends ActivityProps {
  questions: CategorizationQuestion[]
}

export interface CategorizationActivityData {
  question: CategorizationQuestion
  questionIndex: number
}

export enum CategorizationAnswerType {
  WRONG = 'wrong',
  CORRECT = 'correct',
  SELECT_CORRECT = 'select-correct',
  SELECT_ALL_CORRECT = 'select-all-correct',
  SELECT_ONLY_CORRECT = 'select-only-correct',
}

export interface CategorizationQuestion {
  category1: string
  category1Title: string
  category2: string
  category2Title: string
  elementsCategory1: BlockContentWrapper[]
  elementsCategory2: BlockContentWrapper[]
  questionId: string
  question: BlockContent[]
  _key: string
}

export interface Column {
  id: Id
  categoryName: string
}

export interface Task {
  id: Id
  columnId: Id
  category?: string
  content: BlockContent[]
  check: boolean
  taskStatus: TaskStatus
}

export enum TaskStatus {
  Right = 'Right',
  Wrong = 'Wrong',
  Unchecked = 'Unchecked',
  Checking = 'Checking',
  ReadyToCheck = 'ReadyToCheck',
  Reset = 'Reset',
}
